import apiClient from "./apiClient";
const giacenzeAPI = {
    getAllGiacenze: (productId) => apiClient.get(`/giacenze/index?company_id=${localStorage.getItem('company_id')}${localStorage.getItem('product_id') ? `&product_id=${localStorage.getItem('product_id')}` : ''}${localStorage.getItem('stabili_id') ? `&stabili_id=${localStorage.getItem('stabili_id')}` : ''}`),
    getSingleGiacenza: (id) => apiClient.get(`/giacenze/show/${id}?company_id=${localStorage.getItem('company_id')}`),
    createGiacenza: (data) => apiClient.post(`/giacenze/store?company_id=${localStorage.getItem('company_id')}`, data),
    updateGiacenza: (id, data) => apiClient.post(`/giacenze/update/${id}?company_id=${localStorage.getItem('company_id')}`, data),
    deleteGiacenza: (id) => apiClient.delete(`/giacenze/delete/${id}?company_id=${localStorage.getItem('company_id')}`),

    // ENUM
    getUm:() => apiClient.get(`giacenze/get-um?company_id=${localStorage.getItem('company_id')}`),
    getFormato:() => apiClient.get(`giacenze/get-formato?company_id=${localStorage.getItem('company_id')}`),
    getMotivazione:() => apiClient.get(`giacenze/get-motivazione?company_id=${localStorage.getItem('company_id')}`)
    // get
}
export default giacenzeAPI